var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_744)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 6.75H11.75V2.25C11.75 1.00688 10.7426 0 9.5 0C8.25744 0 7.25 1.00688 7.25 2.25V6.75H2.75C1.50744 6.75 0.5 7.75688 0.5 9C0.5 10.2431 1.50744 11.25 2.75 11.25H7.25V15.75C7.25 16.9931 8.25744 18 9.5 18C10.7426 18 11.75 16.9931 11.75 15.75V11.25H16.25C17.4926 11.25 18.5 10.2431 18.5 9C18.5 7.75688 17.4926 6.75 16.25 6.75Z",
    fill: "#9B9C9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8cbccb51c42f917320f8c79c4a42a522.svg";
export { ForwardRef as ReactComponent };